PJQ.views.changeRequests.ChangeRequestEditModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.BUDGET, 'modal-change-request-edit'),
        width: '95%',
        maxWidth: 1800,
        model: null,
        isShowCloseButton: true,
        onSave: _.noop(),
        onDelete: _.noop()
    },
    events: {
        'click .btn-view-prime-contract': 'viewPrimeContract',
        'click .btn-add-line-item': 'addLineItem',
        'click .btn-close': 'close',
        'click .btn-submit': 'submitChangeRequest',
        'click .btn-save-email': 'saveEmail',
        'click .btn-save': 'saveChangeRequest',
        'click .btn-delete': 'deleteChangeRequest',
        'click .btn-push-erp': 'pushERP',
        'click .btn-undo-push-erp': 'undoPushERP',
        'click .btn-unlink-erp': 'unlinkERP',
        'click .btn-export': 'exportClicked',
        'click .btn-export-costs': 'exportCosts',
        'click .btn-export-revenue': 'exportRevenue',
        'click .btn-email': 'email',
        'click .nav-link': 'activeViewChanged',
        'click .btn-view-rfq': 'viewRFQClicked'
    },
    beforeModalCreated: async function () {
        this.isFetched = false;
        this.options.project = this.options.project ? this.options.project : PJQ.app.session.project;

        this.settings = await PJQ.app.session.fetchChangeRequestSettings();
        this.customFields = await this.options.project.fetchChangeRequestCustomFields();
        this.erpIntegration = await PJQ.app.session.fetchERPIntegration();

        if (this.erpIntegration != null && this.erpIntegration.getSetting('syncProjects')) {
            await this.options.project.fetchERPObject();
        }

        if (this.options.primeContract == null) {
            this.options.primeContract = new PJQ.models.primeContracts.PrimeContract({
                id: this.model.get('primeContractId')
            });
        }

        if (!this.options.primeContract.isFetched) {
            await this.options.primeContract.fetch();
        }

        if (this.model == null) {
            let customFieldValues = [];
            _.each(this.customFields.models, function (model, index) {
                let value = model.get('defaultValue') ? model.get('defaultValue') : '';
                if (model.get('fieldType') === 'CHOICE') {
                    value = parseInt(value);
                }
                customFieldValues.push({
                    fieldNumber: model.get('fieldNumber'),
                    fieldTypeId: model.get('fieldTypeId'),
                    fieldType: model.get('fieldType'),
                    isMultiple: model.get('isMultiple'),
                    value: value,
                    id: model.get('id')
                })
            }, this);

            this.model = new PJQ.models.changeRequests.ChangeRequest({
                description: '',
                primeContractId: this.options.primeContract.id,
                primeContractNumber: this.options.primeContract.get('number'),
                client: this.options.primeContract.client,
                clientId: this.options.primeContract.get('clientId'),
                accountingMethod: this.options.primeContract.get('accountingMethod'),
                projectId: this.options.primeContract.get('projectId'),
                statusId: PJQ.constants.changeRequests.changeRequestStatus.DRAFT,
                customFieldValues: customFieldValues,
                markupItems: this.options.primeContract.markupItems.toJSON()
            });

            if(_.size(this.model.markupItems.models) > 0){
                _.each(this.model.markupItems.models, (markupItem) => {
                    let isApplied = markupItem.get('appliedCostCodeId') > 0 &&  markupItem.get('appliedCostTypeId') > 0;

                    if(isApplied){
                        let lineItem = new PJQ.models.changeRequests.ChangeRequestLineItem({
                            costCodeId: markupItem.get('appliedCostCodeId'),
                            costTypeId: markupItem.get('appliedCostTypeId'),
                            amount: 0,
                            revenue: 0,
                            description: markupItem.get('name')
                        });
                        markupItem.lineItem = lineItem;
                        lineItem.markup = markupItem;
                        this.model.lineItems.add(lineItem);
                    }
                });
            }
        }

        if (!this.model.isNew()) {
            await this.model.fetch();
        }

        this.isFetched = true;
        this.render();
    },
    beforeRender: function () {
        this.options.canAdd = this.options.project.hasPermission('changeRequests.canAdd');
        this.options.canEdit = this.options.project.hasPermission('changeRequests.canEdit');
        this.options.canEditLineItems = this.options.canEdit;
        this.options.canViewPrimeContracts = this.options.project.hasPermission('primeContracts.canView');
        this.options.canViewRFQs = this.options.project.hasPermission('changeRequests.canViewRFQs');
        this.options.isAdmin = this.options.project.hasPermission('changeRequests.isAdmin');
        this.options.canDelete = this.options.isAdmin;
        this.options.canEditStatus = this.options.isAdmin;

        if (!this.isFetched || this.model.isNew()) {
            return;
        }

        let fnGetGreaterStatuses = (statusId) => {
                return _.filter(PJQ.constants.changeRequests.changeRequestStatus, (st) => {
                    return st < statusId;
                });
            },
            status = this.model.get('statusId');
        if (status === PJQ.constants.changeRequests.changeRequestStatus.APPROVED
            || status === PJQ.constants.changeRequests.changeRequestStatus.VOID) {
            this.options.canEditLineItems = false;
            this.options.canEdit = PJQ.app.session.project.hasPermission('changeRequests.canEdit');
            this.options.canDelete = false;
        } else {
            this.options.canEdit = PJQ.app.session.project.hasPermission('changeRequests.canEdit');
            this.options.canEditLineItems = this.options.canEdit;
            this.options.canDelete = this.options.isAdmin;
        }

        let hasAssignedItems = _.some(this.model.lineItems.models, (lineItem) => {
            return lineItem.get('revenueLineItemId') > 0;
        });
        if (hasAssignedItems) {
            this.options.disabledStatuses = fnGetGreaterStatuses(PJQ.constants.changeRequests.changeRequestStatus.APPROVED);
            this.options.canEditLineItems = false;
        }

        if (this.model.isERPSynced()) {
            let syncStatus = this.model.erpSyncStatus();
            if (syncStatus === PJQ.constants.integrations.erp.syncStatuses.REVIEWING
                || syncStatus === PJQ.constants.integrations.erp.syncStatuses.APPROVED
                || syncStatus === PJQ.constants.integrations.erp.syncStatuses.FAILED
                || syncStatus === PJQ.constants.integrations.erp.syncStatuses.SYNCED
            ) {
                this.options.disabledStatuses = fnGetGreaterStatuses(PJQ.constants.commitments.commitmentStatus.APPROVED);
                this.options.canEdit = false;
                this.options.canEditLineItems = false;
                this.options.canDelete = false;
            }
        }
    },
    renderData: function () {
        return {
            model: this.model,
            customFields: this.customFields,
            erpIntegration: this.erpIntegration,
            canAdd: this.options.canAdd,
            canEditLineItems: this.options.canEditLineItems,
            canEdit: this.options.canEdit,
            canDelete: this.options.canDelete,
            isAdmin: this.options.isAdmin,
            canViewPrimeContracts: this.options.canViewPrimeContracts,
            canViewRFQs: this.options.canViewRFQs,
            isFetched: this.isFetched,
            activeView: this.options.activeView,
            views: this.views,
            checkFieldVisible: _.bind(this.checkFieldVisible, this),
            checkFieldRequired: _.bind(this.checkFieldRequired, this)
        }
    },
    afterRender: function () {
        if (!this.isFetched)
            return;

        this.activateView(this.options.activeView);

        this.stopListening(this.model);
        this.listenTo(this.model, 'change:statusId', () => {
            this.renderERP();
        });
        this.stopListening(this.model.lineItems);
        this.listenTo(this.model.lineItems, 'update', () => {
            this.renderERP();
        });
        this.renderERP();

        this.renderGeneral();
        this.renderLineItems();
        this.renderMarkups();
        this.updateCounts();
    },
    updateCounts: function () {
        this.$('.count-line-items').text(_.size(this.model.lineItems.models));
        this.$('.count-markups').text(_.size(_.filter(this.model.markupItems.models, function (item) {
            return !item.get('delete');
        })));
    },
    views: {
        GENERAL: 'CR_General',
        LINEITEMS: 'CR_LineItems',
        MARKUPS: 'CR_Markups',
        RFQ: 'CR_RFQ'
    },
    activeViewChanged: function (e) {
        let view = e.target.hash ? e.target.hash.replace('#', '') : null;
        this.activateView(view);
    },
    activateView: function (view) {
        switch (view) {
            case this.views.GENERAL:
            case this.views.LINEITEMS:
            case this.views.MARKUPS:
                break;
            case this.views.RFQ:
                this.renderRFQ();
                break;
            default:
                view = this.views.GENERAL;
                break;
        }

        this.$('.nav-link[href="#' + view + '"]').tab('show');
        this.options.activeView = view;
    },
    renderGeneral: function () {
        new PJQ.Binder(this.$el, this.model, {
            canEdit: !this.options.canEdit ? false : null,
            useDecimalPercentFields: true,
            watchElements: [
                'input',
                'textarea'
            ]
        });

        let choices = _.map(PJQ.constants.changeRequests.changeRequestStatus, (st) => {
            return {
                id: st,
                name: PJQ.constants.changeRequests.changeRequestStatusNames[st],
                disabled: this.options.disabledStatuses != null && this.options.disabledStatuses.indexOf(st) > -1
            }
        });
        this.statusPicker = new PJQ.inputs.Selectpicker({
            el: this.$('.select-status'),
            choices: choices,
            isIntChoices: true,
            defaultValue: this.model.get('statusId'),
            canEdit: this.options.canEditStatus,
            onChange: _.bind(function (value) {
                let newStatus = value,
                    oldStatus = this.model.get('statusId');
                this.model.set('statusId', newStatus);
                if (!this.model.isNew()) {
                    this.model.save(null, {
                        success: _.bind(function () {
                            this.model.dirtyAttributes = {};
                            if (typeof this.options.onSave === 'function')
                                this.options.onSave(this.model, false);
                            this.render();
                            PJQ.notifications.notify.successNotify({
                                message: 'Change Request saved successfully'
                            });
                        }, this)
                    })
                }
            }, this)
        });

        new PJQ.inputs.Selectpicker({
            el: this.$('.select-revenue-source'),
            choices: [
                {
                    id: PJQ.constants.changeRequests.revenueSource.REVENUE,
                    name: PJQ.constants.changeRequests.revenueSourceNames[PJQ.constants.changeRequests.revenueSource.REVENUE]
                },
                {
                    id: PJQ.constants.changeRequests.revenueSource.MANUAL,
                    name: PJQ.constants.changeRequests.revenueSourceNames[PJQ.constants.changeRequests.revenueSource.MANUAL]
                }
            ],
            isIntChoices: true,
            defaultValue: this.model.get('revenueSource') ?? PJQ.constants.changeRequests.revenueSource.REVENUE,
            canEdit: this.options.canEdit,
            onChange: (value) => {
                this.model.set({
                    revenueSource: value
                });
                this.refreshLineItems()
            }
        });

        new PJQ.inputs.Selectpicker({
            el: this.$('.select-scope'),
            choices: [
                {
                    id: PJQ.constants.changeRequests.scope.OWNER_CHANGE,
                    name: PJQ.constants.changeRequests.scopeNames[PJQ.constants.changeRequests.scope.OWNER_CHANGE]
                },
                {
                    id: PJQ.constants.changeRequests.scope.INTERNAL,
                    name: PJQ.constants.changeRequests.scopeNames[PJQ.constants.changeRequests.scope.INTERNAL]
                }
            ],
            isIntChoices: true,
            defaultValue: this.model.get('scope') ?? PJQ.constants.changeRequests.scope.OWNER_CHANGE,
            canEdit: this.options.canEdit,
            onChange: (value) => {
                this.model.set({
                    revenueSource: PJQ.constants.changeRequests.revenueSource.MANUAL,
                    scope: value
                });
                this.model.set('scope', value);

                if(value === PJQ.constants.changeRequests.scope.INTERNAL) {
                    _.each(this.model.lineItems.models, (lineItem) => {
                        lineItem.set('revenue', 0);
                    });
                } else {
                    _.each(this.model.lineItems.models, (lineItem) => {
                        lineItem.set('revenue', lineItem.get('amount'));
                    });
                }
                this.refreshLineItems()
            }
        });

        this.contractCompanyPicker = new PJQ.views.contacts.ContactsSelectInput({
            el: this.$('.client'),
            selectedContact: this.model.client,
            canEdit: false,
            displayContactsBlock: true
        });

        if (_.size(this.customFields) > 0) {
            this.customFieldsForm = new PJQ.views.customFields.CustomFieldsForm({
                el: this.$('.change-request-custom-fields'),
                isEdit: this.options.canEdit,
                isAdmin: this.options.isAdmin,
                collection: this.customFields,
                fieldValues: this.model.get('customFieldValues'),
                onChange: _.bind(function () {
                    this.model.isDirty = true;
                }, this)
            });
        }

        if (this.checkFieldVisible('attachments')) {
            this.fileUploader = new PJQ.views.files.FileUploaderGrid({
                el: this.$('.cr-file-uploader'),
                collection: this.model.attachments,
                canUpload: this.options.canEdit,
                useApiV2: true,
                canDelete: this.options.canEdit && this.options.isAdmin,
                previewImageDimension: 150,
                onSuccess: _.bind(function (file) {
                    this.model.isDirty = true;
                }, this),
                onDelete: _.bind(function (attachment, callback) {
                    if (attachment.get('id') > 0) {
                        attachment.set('delete', true);
                    } else {
                        attachment.destroy();
                    }

                    this.model.isDirty = true;
                    callback();
                }, this)
            });
        }
    },
    refreshLineItems: function () {
        if (this.lineItemsView != null) {
            this.lineItemsView.options.showRevenue = this.model.get('scope') !== PJQ.constants.changeRequests.scope.INTERNAL;
            this.lineItemsView.options.showMarkup = this.lineItemsView.options.showRevenue;
            this.lineItemsView.options.copyCostToRevenue = this.model.get('revenueSource') !== PJQ.constants.changeRequests.revenueSource.MANUAL && this.lineItemsView.options.showRevenue;
            this.lineItemsView.renderLineItemsTable();
        }
    },
    renderLineItems() {
        if(this.lineItemsView){
            this.lineItemsView.remove();
        }

        let showRevenue = this.model.get('scope') !== PJQ.constants.changeRequests.scope.INTERNAL,
            showMarkup = showRevenue;
        this.lineItemsView = new PJQ.views.budget.LineItemsView({
            el: this.$('.cr-line-items'),
            model: this.model,
            collection: this.model.lineItems,
            lineItemModel: PJQ.models.changeRequests.ChangeRequestLineItem,
            changeRequest: this.model,
            canEdit: this.options.canEditLineItems,
            canApplyChangeRequestCosts: this.options.isAdmin,
            canApplyChangeRequestRevenue: this.options.isAdmin && this.model.get('statusId') === PJQ.constants.changeRequests.changeRequestStatus.APPROVED,
            canSendRFQ: this.model.get('statusId') !== PJQ.constants.changeRequests.changeRequestStatus.APPROVED
                && this.model.get('statusId') !== PJQ.constants.changeRequests.changeRequestStatus.REJECTED
                && this.model.get('statusId') !== PJQ.constants.changeRequests.changeRequestStatus.VOID,
            canDelete: this.options.canEditLineItems,
            primeContract: this.options.primeContract,
            accountingMethod: this.model.get('accountingMethod'),
            showRevenue: showRevenue,
            showMarkup: showMarkup,
            copyCostToRevenue: showRevenue && this.model.get('revenueSource') !== PJQ.constants.changeRequests.revenueSource.MANUAL,
            canChangeAccountingMethod: this.options.canEditLineItems,
            financialMarkups: this.model.markupItems,
            enableSelection: true,
            showSubTotal: true,
            showGrandTotal: true,
            onCreateFromLineItems: () => {
                this.removeModal();
            },
            onLineItemChange: () => {
                this.model.isDirty = true;
            },
            onLineItemAdd: () => {
                this.model.isDirty = true;
                this.updateCounts();
            },
            onLineItemDelete: () => {
                this.model.isDirty = true;
                this.updateCounts();
            },
            onChangeOrderView: () => {
                this.removeModal();
            },
            onCommitmentView: () => {
                this.removeModal();
            },
            onSendRFQ: (data) => {
                let fnSendRFQ = (lineItems) => {
                        new PJQ.views.rfq.RFQBatchModal({
                            changeRequest: this.model,
                            project: this.options.project,
                            lineItems: lineItems,
                            projectCommitments: data.projectCommitments,
                            onSave: (res) => {
                                this.model.rfq.add(res.requests);
                                this.activateView(this.views.RFQ);
                            }
                        });
                    },
                    lineItems = this.model.lineItems.get(data.selectedIds);

                let lineItemCt = _.size(lineItems),
                    rfqItemsCt = _.filter(lineItems, (lineItem) => {
                        return lineItem.get('rfqId') > 0;
                    }).length;
                if (rfqItemsCt > 0) {
                    if (rfqItemsCt === lineItemCt) {
                        new PJQ.views.modals.YesNo({
                            header: "Send New RFQs?",
                            body: "All of the selected line items are already associated with RFQs. Would you like to create them again?",
                            onYes: () => {
                                fnSendRFQ(lineItems);
                            }
                        });
                    } else {
                        new PJQ.views.BaseModal({
                            header: "Send RFQs",
                            body: "Some of the selected line items are already associated with RFQs. Please choose from the options below.",
                            isShowOkButton: true,
                            okButtonText: "Create All (" + lineItemCt + ")",
                            onOk: () => {
                                fnSendRFQ(lineItems);
                            },
                            isShowSecondaryButton: true,
                            secondaryButtonColorClass: 'primary',
                            secondaryButtonText: "Create Missing (" + rfqItemsCt + ")",
                            onSecondary: () => {
                                fnSendRFQ(_.filter(lineItems, (lineItem) => {
                                    return !(lineItem.get('rfqId') > 0);
                                }));
                            }
                        });
                    }
                } else {
                    fnSendRFQ(lineItems);
                }
            }
        });
    },
    viewPrimeContract: function () {
        this.removeModal();
        new PJQ.views.primeContracts.PrimeContractEditModal({
            model: new PJQ.models.primeContracts.PrimeContract({
                id: this.model.get('primeContractId')
            })
        });
    },
    renderMarkups: function () {
        if (!this.options.isAdmin) {
            return;
        }

        this.markupsView = new PJQ.financialMarkups.views.FinancialMarkupsList({
            el: this.$('.cr-markups'),
            collection: this.model.markupItems,
            canEdit: false
        });
    },
    renderRFQ: function () {
        if (this.model.isNew() || !this.options.canViewRFQs) {
            return;
        }

        this.model.fetchRFQs().then(() => {
            this.rfqDataTable = new PJQ.views.dataTables.DataTable({
                el: this.$('.cco-rfq'),
                data: this.model.rfq.models,
                isHideSearch: true,
                language: {
                    emptyTable: 'No RFQs have been created yet',
                    zeroRecords: "No RFQs matched the search criteria"
                },
                paging: false,
                order: [],
                columns: [
                    {
                        "columnData": "",
                        "data": null,
                        "title": "",
                        "width": "20px",
                        "orderable": false,
                        "searchable": false,
                        "defaultContent": '',
                        "render": function (data, type, row) {
                            return PJQ.helpers.erp.getERPIcon(row.erpSyncStatus());
                        }
                    },
                    {
                        "columnData": "number",
                        "data": "attributes.number",
                        "title": "Number",
                        "width": "100px",
                        "render": (data, type, row) => {
                            return '<a class="btn-view-rfq" href="javascript:void(0)" data-id="' + row.id + '">' + row.get('number') + '</a>';
                        }
                    },
                    {
                        "columnData": "title",
                        "data": "attributes.title",
                        "title": "Title"
                    },
                    {
                        "columnData": "scope",
                        "data": "attributes.scope",
                        "title": "Scope"
                    },
                    {
                        "columnData": "lastSentOn",
                        "data": "attributes.lastSentOn",
                        "title": 'Sent On',
                        "width": '90px',
                        "render": (data, type, row) => {
                            if (_.size(data) === 0) {
                                return '';
                            }
                            return PJQ.helpers.dateHelpers.getDateString(new Date(data), PJQ.helpers.dateHelpers.dateFormats.DATE);
                        }
                    },
                    {
                        "columnData": "dueDate",
                        "data": "attributes.dueDate",
                        "title": 'Due',
                        "width": '90px',
                        "render": (data, type, row) => {
                            if (_.size(data) === 0) {
                                return '';
                            }
                            return PJQ.helpers.dateHelpers.getDateString(new Date(data), PJQ.helpers.dateHelpers.dateFormats.DATE);
                        }
                    },
                    {
                        "columnData": "contractedContact",
                        "title": "Company",
                        "titleSettings": "Company",
                        "render": (data, type, row) => {
                            return row.contractedContact?.get('companyName') ?? '';
                        }
                    },
                    {
                        "columnData": "amount",
                        "data": "attributes.amount",
                        "width": "10%",
                        "title": "Quote",
                        "className": "text-align-right",
                        "render": (data, type, row) => {
                            if (row.get('responseOn') == null) {
                                return '';
                            } else if (row.get('hasCostImpact') === false) {
                                return 'No Impact';
                            }

                            return PJQ.helpers.formatHelpers.formatCurrency(row.get('amount'));
                        }
                    },
                    {
                        "columnData": "status",
                        "data": "attributes.statusId",
                        "title": "Status",
                        "width": "100px",
                        "render": _.bind(function (data, type, row) {
                            return PJQ.constants.rfq.rfqStatusNames[row.get('statusId')]
                        }, this)
                    },
                    {
                        "title": '',
                        "orderable": false,
                        "searchable": false,
                        "width": "90px",
                        "className": "text-center",
                        "visible": true,
                        "render": _.bind(function (data, type, row) {
                            return '<div class="show-on-row-hover"><button type="button" class="btn btn-info btn-view-rfq ml-1" title="View RFQ"><i class="fal fa-arrow-alt-from-left"></i></button></div>';
                        }, this)
                    }],
                dom: '<"top"<"clear">>rt<"bottom"p<"clear">>',
                contextMenuOptions: {
                    actions: [
                        {
                            name: 'View',
                            onClick: _.bind(function (row) {
                                this.viewRFQ(row.data());
                            }, this),
                            isShown: _.bind(function (row) {
                                return true;
                            }, this)
                        }
                    ]
                },
                onRowDoubleClick: _.bind(function (row) {
                    let rfq = row.data();
                    if (rfq != null) {
                        rfq.fetch({
                            success: _.bind(function () {
                                this.viewRFQ(rfq);
                            }, this)
                        });
                    }
                }, this)
            });
        })
    },
    viewRFQ: function (rfq) {
        isNew = rfq == null;
        new PJQ.views.rfq.RFQEditModal({
            model: rfq,
            changeRequest: this.model,
            onSave: _.bind(function (rfq) {
                if (isNew) {
                    this.model.rfq.add(rfq);
                    this.rfqDataTable.addRow(rfq);
                    isNew = false;

                    if (typeof this.options.onRFQAdd === 'function') {
                        this.options.onRFQAdd(rfq);
                    }
                }
                this.updateCounts();

                if (typeof this.options.onSave === 'function') {
                    this.options.onSave(this.model);
                }
            }, this),
            onDelete: _.bind(function (rfq) {
                this.model.rfq.remove(rfq);
                this.rfqDataTable.render();
                this.updateCounts();

                if (typeof this.options.onSave === 'function') {
                    this.options.onSave(this.model);
                }
            }, this)
        });
    },
    newRFQ: function () {
        this.viewRFQ();
    },
    viewRFQClicked: function (e) {
        let target = $(e.currentTarget),
            row = this.rfqDataTable.getRow(target.closest('tr'));
        this.viewRFQ(row.data());
    },
    renderERP: function () {
        let $erp = this.$('.erp-sync');
        if (!this.options.isAdmin || this.erpIntegration == null || !this.options.project.isERPSynced()
            || (this.model.get('statusId') !== PJQ.constants.changeRequests.changeRequestStatus.APPROVED)) {
            $erp.remove();
            return;
        }

        let canPush = this.commitment != null && this.commitment.erpSyncStatus() === PJQ.constants.integrations.erp.syncStatuses.SYNCED && this.model && _.size(this.model.lineItems) > 0;
        PJQ.helpers.erp.renderERPButtons($erp, {
            pushSupported: !this.model.isERPSynced() && this.erpIntegration.hasAvailableAction(PJQ.constants.integrations.actions.PUSH_CHANGE_REQUESTS),
            canPush: canPush,
            disablePushReason: canPush ? '' : this.model && _.size(this.model.lineItems) === 0 ? 'No line items exist for this change request' : 'The contract for this change request is not synced',
            status: this.model.erpSyncStatus()
        });
    },
    pushERP: function (callback) {
        if (this.erpIntegration.hasAvailableAction(PJQ.constants.integrations.actions.PUSH_CHANGE_REQUESTS)) {
            this.erpIntegration.pushChangeRequest(this.model, _.bind(function () {
                PJQ.notifications.notify.successNotify({
                    message: 'Change Request pushed to ERP'
                });

                if (callback && typeof callback === 'function') {
                    callback();
                } else {
                    this.render();
                }
            }, this));
        }
    },
    undoPushERP: function () {
        if (this.model.erpSyncStatus() === PJQ.constants.integrations.erp.syncStatuses.REVIEWING) {
            this.erpIntegration.undoPush(this.model, _.bind(function () {
                PJQ.notifications.notify.successNotify({
                    message: 'Change Request removed from ERP approval'
                });
                this.render();
            }, this));
        }
    },
    unlinkERP: function () {
        if (this.erpIntegration != null) {
            let loader = new PJQ.Loader(this.$('.modal-content'));
            this.erpIntegration.unlinkChangeRequest(this.model, _.bind(function (success) {
                if (success) {
                    loader.remove();
                    PJQ.notifications.notify.successNotify({
                        message: 'Change Request unlinked from ERP'
                    });
                    this.render();
                }
            }, this));
        }
    },
    checkFieldVisible: function (fieldName) {
        if (this.coreFieldSettings) {
            let fieldSettings = this.coreFieldSettings.findWhere({fieldName: fieldName});
            if (fieldSettings != null) {
                return fieldSettings.get('isVisible');
            }
        }
        return true;
    },
    checkFieldRequired: function (fieldName) {
        if (this.coreFieldSettings) {
            let fieldSettings = this.coreFieldSettings.findWhere({fieldName: fieldName});
            if (fieldSettings != null) {
                return fieldSettings.get('isRequired');
            }
        }
        return false;
    },
    exportRevenue: function () {
        this.export(true, false);
    },
    exportCosts: function () {
        this.export(false, true);
    },
    exportClicked: function () {
        this.export();
    },
    export: function (withRevenue = true, withCosts = true) {
        let callback = () => {
            PJQ.files.downloadFile(PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'changerequests',
                    value: this.model.get('id')
                },
                {
                    endpoint: 'export',
                }
            ], [{
                parameter: 'showCosts',
                value: withCosts
            }, {
                parameter: 'showRevenue',
                value: withRevenue
            }]), {isAPIv2: true});
        };

        if (this.options.canEdit) {
            this.save(callback);
        } else {
            callback();
        }
    },
    saveEmail: function () {
        this.save(_.bind(function () {
            PJQ.notifications.notify.successNotify({
                message: 'Change Request saved successfully'
            });

            this.email();
        }, this));
    },
    savePush: function () {
        this.save(_.bind(function () {
            PJQ.notifications.notify.successNotify({
                message: 'Change Request saved successfully'
            });

            this.pushERP(() => {
                this.removeModal()
            });
        }, this));
    },
    submitChangeRequest: function () {
        this.model.submit(null, _.bind(function (result) {
            if (result) {
                PJQ.notifications.notify.successNotify({
                    message: 'Change Request submitted successfully'
                });

                this.removeModal();
            }
        }, this));
    },
    saveChangeRequest: function () {
        this.save(() => {
            PJQ.notifications.notify.successNotify({
                message: 'Change Request saved successfully'
            });

            this.removeModal();
        });
    },
    validate: function () {
        let isValid = true;

        if (this.customFieldsForm != null && !this.customFieldsForm.validate())
            isValid = false;

        PJQ.helpers.inputHelpers.setInputError(this.$('.input-number'), true);
        if ((!this.model.isNew() || this.checkFieldRequired('number')) && _.size(this.model.get('number')) === 0) {
            isValid = false;
            PJQ.helpers.inputHelpers.setInputError(this.$('.input-number'), false);
        }

        if (this.checkFieldRequired('description')) {
            let $description = this.$('.change-request-description');
            PJQ.helpers.inputHelpers.setInputError($description, true);
            if (_.size(this.model.get('description')) === 0) {
                PJQ.helpers.inputHelpers.setInputError($description, false);
                isValid = false;
            }
        }

        if (this.checkFieldRequired('attachments')) {
            this.fileUploader.clearError();
            let hasValidAttachment = _.find(this.model.attachments.models, function (model) {
                return !model.get('delete')
            }, this) != null;

            if (!hasValidAttachment) {
                this.fileUploader.showError('Missing attachment', 100000);
                isValid = false;
            }
        }

        if (!isValid) {
            this.activateView(this.views.GENERAL);
            return isValid;
        }

        if (!this.lineItemsView.validate()) {
            isValid = false;

            this.activateView(this.views.LINEITEMS);
            return isValid;
        }

        return isValid;
    },
    save: function (callback) {
        if (!this.validate())
            return;

        let newMarkupLines = this.model.lineItems.filter(function (lineItem) {
            return lineItem.markup && lineItem.isNew();
        });
        this.model.lineItems.remove(newMarkupLines);

        this.model.save({
            customFields: this.customFieldsForm != null ? this.customFieldsForm.getChanged() : null,
            lineItems: this.model.lineItems.toJSON(),
            markupItems: this.model.markupItems.toJSON()
        }, {
            success: _.bind(function () {
                this.render();
                if (typeof this.options.onSave === 'function') {
                    this.options.onSave(this.model);
                }

                PJQ.app.session.project.trigger('changeRequestChanged', this.model);
                if (typeof callback === 'function') {
                    callback(true);
                }
            }, this)
        });
    },
    deleteChangeRequest: function () {
        let changeRequestId = this.model.id,
            hasAssociatedLineItems = _.size(_.filter(this.model.lineItems.models, function (lineItem) {
                return lineItem.get('ccoId') || lineItem.get('pccoId') || lineItem.get('commitmentId');
            }, this)) > 0;
        new PJQ.views.modals.DeleteCancel({
            header: "Confirm Delete",
            body: hasAssociatedLineItems ? "This Change Request has line items that are associated with other line items. Deleting it will also delete all associated line items. Are you sure you want to delete this Change Request?" : "Are you sure you want to delete this Change Request?",
            onDelete: _.bind(function () {
                this.model.destroy({
                    success: _.bind(function () {
                        PJQ.notifications.notify.successNotify({
                            message: 'Change Request deleted successfully'
                        });

                        if (typeof this.options.onDelete === 'function')
                            this.options.onDelete(changeRequestId);

                        this.removeModal();
                    }, this)
                });
            }, this)
        });
    },
    email: function () {
        let projectName = this.options.project?.get('projectName')?.trim();
        let subject = `A Change Request has been shared with you ${projectName && _.size(projectName) > 0 ? `for ${projectName}` : ''}`;
        new PJQ.views.email.ComposeEmailModal({
            header: "Email Change Request",
            project: PJQ.app.session.project,
            subject: subject,
            onSave: _.bind(function (data) {
                this.model.share(data, _.bind(function () {
                    PJQ.notifications.notify.successNotify({
                        message: 'Change Request email sent'
                    });
                }, this));
            }, this)
        });
    },
    close: function () {
        if (this.model.hasChanged() && this.options.canEdit) {
            new PJQ.views.modals.SaveDontSave({
                header: "Unsaved Changes",
                body: "Do you want to save changes?",
                onSave: _.bind(function () {
                    this.saveChangeRequest();
                    this.removeModal();
                }, this),
                onDontSave: _.bind(function () {
                    this.removeModal();
                }, this)
            });
        } else {
            this.removeModal();
        }
    }
});